import * as cvs from './list/cvs';
import * as signin from './list/signin';
import * as favorite from './list/favorite';
import * as trash from './list/trash';
import * as joinUs from './list/join_us';
import * as me from './list/me';
import * as jobs from './list/jobs';
import * as mentorOrders from './list/mentor_orders';
import * as account from './list/account';
import * as recruit from './list/recruit';
import * as test from './list/test';
import * as gio from './list/gio';
import * as recruitment from './list/recruitment';
import * as companies from './list/companies';
import * as jwt from './list/jwt';
import * as template from './list/template';
import * as cvsV2 from './list/cvsV2';
import * as auth from './list/auth';
import * as company from './list/company';
import * as nps from "./list/nps";
import * as cvsEditor from './list/cvsEditor';
import * as cvsV3 from './list/cvsV3';
import * as staticApi from './list/static';
import * as identity from './list/identity';
import * as mentor from './list/mentor';
import * as io from './list/io'
import * as campusOffers from './list/campus-offers';
import * as shareCvs from './list/shareCvs';
import * as portrait from './list/portrait';
import * as planning from './list/planning';
import * as recommend from './list/recommend'
import * as cvError from './list/cv_errors'
import * as AI from './list/ai'
import * as Equipment from './list/equipment'


const api = {
  signin,     // 登陆系列
  cvs,        // cvs系列
  favorite,   // 简历收藏系列
  trash,      // 回收站系列
  recruit,
  joinUs,
  test,
  me,
  jobs,
  mentorOrders,  //导师辅导相关接口
  account,  //优惠券
  gio, //gio相关
  recruitment, //
  companies, //
  jwt,//jwt相关
  template,
  cvsV2,
  auth,
  company,
  nps,
  cvsEditor,
  cvsV3,
  staticApi,
  identity,
  mentor,
  io,
  campusOffers,
  shareCvs, //简历分享相关
  portrait, // 简历头像相关
  planning,
  recommend,   // 职位推荐接口
  cvError, //简历纠错
  AI,
  Equipment // 设备的接口
}
export default api
